"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusProxy = exports.Subscribers = exports.PING_INTERVAL_MS = void 0;
var bus_1 = require("../common/gccore/bus");
var BUS_POST_MESSAGE_TYPE = "bus-proxy";
var MAX_PING_TIME_MS = 5000;
exports.PING_INTERVAL_MS = 100;
var MAX_PING_COUNT = MAX_PING_TIME_MS / exports.PING_INTERVAL_MS;
var Subscribers = /** @class */ (function () {
    function Subscribers() {
        this.subscribers = {};
    }
    Subscribers.prototype.add = function (eventName, callback) {
        this.subscribers[eventName] = this.subscribers[eventName] || [];
        this.subscribers[eventName].push(callback);
    };
    Subscribers.prototype.clear = function (eventName) {
        this.subscribers[eventName] = [];
    };
    Subscribers.prototype.get = function (eventName) {
        return this.subscribers[eventName] || [];
    };
    return Subscribers;
}());
exports.Subscribers = Subscribers;
var BusProxy = /** @class */ (function () {
    function BusProxy(clientWindow, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.clientWindow = clientWindow;
        this.onSubscribers = new Subscribers();
        this.onceSubscribers = new Subscribers();
        this.waitForReadyTimers = [];
        this.maxPingCount = options.maxPingCount || MAX_PING_COUNT;
        this.targetOrigin = document.referrer || clientWindow.parent.location.origin;
        this.busIsReady = false;
        this.listener = function (postMessageEvent) {
            if (!_this.isGlamCornerDomain(postMessageEvent)) {
                return;
            }
            if (postMessageEvent.data.type !== BUS_POST_MESSAGE_TYPE) {
                return;
            }
            var _a = postMessageEvent.data, method = _a.method, args = _a.args;
            switch (method) {
                case "broadcast":
                    _this.onSubscribers.get(args.eventName).forEach(function (subscriber) {
                        subscriber(args.data);
                    });
                    var onceSubscribers = _this.onceSubscribers.get(args.eventName);
                    _this.onceSubscribers.clear(args.eventName);
                    onceSubscribers.forEach(function (subscriber) {
                        subscriber(args.data);
                    });
                    break;
                case "pong":
                    clearInterval(_this.pingTimer);
                    _this.busIsReady = true;
                    break;
                default:
                    console.log("WARNING: Unknown Bus method: ", method);
            }
        };
        this.clientWindow.addEventListener("message", this.listener);
    }
    BusProxy.instance = function () {
        if (!this._instance) {
            this._instance = new BusProxy(window);
        }
        return this._instance;
    };
    BusProxy.prototype.broadcast = function (eventName, data) {
        var _this = this;
        this.waitForReady().then(function () {
            _this.clientWindow.parent.postMessage({
                type: BUS_POST_MESSAGE_TYPE,
                method: "broadcast",
                args: {
                    eventName: eventName,
                    data: data
                }
            }, _this.targetOrigin);
        });
    };
    BusProxy.prototype.isGlamCornerDomain = function (messageEvent) {
        if (!(messageEvent instanceof MessageEvent)) {
            throw Error("postMessageEvent parameter not of type MessageEvent");
        }
        return bus_1.glamcornerDomainRegExp.test(messageEvent.origin);
    };
    BusProxy.prototype.on = function (eventName, options, callback) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.waitForReady().then(function () {
            _this.onSubscribers.add(eventName, callback);
            _this.clientWindow.parent.postMessage({
                type: BUS_POST_MESSAGE_TYPE,
                method: "on",
                args: {
                    eventName: eventName,
                    options: options
                }
            }, _this.targetOrigin);
        });
    };
    BusProxy.prototype.once = function (eventName, callback) {
        var _this = this;
        this.waitForReady().then(function () {
            _this.onceSubscribers.add(eventName, callback);
            _this.clientWindow.parent.postMessage({
                type: BUS_POST_MESSAGE_TYPE,
                method: "once",
                args: {
                    eventName: eventName
                }
            }, _this.targetOrigin);
        });
    };
    BusProxy.prototype.destroy = function () {
        clearInterval(this.pingTimer);
        this.waitForReadyTimers.forEach(function (timer) { return clearInterval(timer); });
        this.clientWindow.removeEventListener("message", this.listener);
    };
    BusProxy.prototype.waitForReady = function () {
        var _this = this;
        var pingCount = 0;
        if (this.busIsReady) {
            return Promise.resolve();
        }
        else {
            this.startPingingBus();
            return new Promise(function (resolve) {
                var timer = setInterval(function () {
                    pingCount += 1;
                    if (_this.busIsReady) {
                        clearInterval(timer);
                        resolve();
                    }
                    else {
                        if (pingCount > _this.maxPingCount) {
                            clearInterval(timer);
                            clearInterval(_this.pingTimer);
                            _this.notifyError(new Error("Bus proxy didn't receive pong after " + _this.maxPingCount + " pings"));
                        }
                    }
                }, exports.PING_INTERVAL_MS);
                _this.waitForReadyTimers.push(timer);
            });
        }
    };
    BusProxy.prototype.startPingingBus = function () {
        var _this = this;
        if (!this.pingTimer) {
            this.pingTimer = setInterval(function () {
                _this.clientWindow.parent.postMessage({
                    type: BUS_POST_MESSAGE_TYPE,
                    method: "ping",
                    args: {}
                }, _this.targetOrigin);
            }, exports.PING_INTERVAL_MS);
        }
    };
    BusProxy.prototype.notifyError = function (err) {
        console.error(err.message);
        // @ts-ignore
        if (this.clientWindow["airbrake"]) {
            // @ts-ignore
            this.clientWindow["airbrake"].notify(err);
        }
        else {
            console.warn("cant log to airbrake");
        }
    };
    return BusProxy;
}());
exports.BusProxy = BusProxy;
